import { useEffect, useState } from "react";
import { _Inbox, _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../../theme/Component/PrintJson";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Approve: string;
}

export const SOP009 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_SupplierPaymentOrder);
    const [props, setProps] = useState<any>({})

    const [response, setResponse] = useState<Resp>({
        Approve: "",
        Obs: ""
    })

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        if (props.SupplierPaymentOrderDate && props.IDSupplierPaymentOrder) {
            instance.getSupplierPaymentOrder(props.IDSupplierPaymentOrder, props.SupplierPaymentOrderDate).then(
                (resp) => {
                    setBean(resp)
                }
            ).catch(
                err => {
                    console.log(err)
                }
            )
        }
    }, [props])

    const onExportMap = (responseData) => {
        console.log(responseData)
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(responseData.Obs)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(responseData)
        }
    }

    const handleApprove = (currentResponse: Resp) => {
        if (currentResponse.Obs.length > 15) {
            onExportMap(currentResponse);
        } else {
            toast.error("La justificación debe tener mínimo 15 caracteres");
        }
    };

    const handleDecline = (currentResponse: Resp) => {
        console.log(currentResponse)
        if (currentResponse.Obs.length > 15) {
            recazar(currentResponse);
        } else {
            toast.error("La justificación debe tener mínimo 15 caracteres");
        }
    };


    const recazar = (data) => {
        instance.rejectSupplierPaymentOrder(props.IDSupplierPaymentOrder, props.SupplierPaymentOrderDate, _single.getAccountID(), response.Obs).then(
            (resp: any) => {
                if (resp) {
                    onExportMap(data)
                } else {
                    toast.error('No se pudo completar la Acción')
                }
            }
        )
    }

    const handleButtonClick = (approveValue: "true" | "false") => {
        const newResponse = { ...response, Approve: approveValue };
        setResponse(newResponse);
        if (approveValue === "true") {
            handleApprove(newResponse);
        } else {
            handleDecline(newResponse);
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <strong>Fecha de la Orden: </strong><small>{props.SupplierPaymentOrderDate}</small>
                </div>
                <div className="col-md-6">
                    <strong>Justificación: </strong><small>{props.Description}</small>
                </div>
            </div>
            <div className="row d-flex justify-content-between">
                <div className="col-md-12 mb-2">
                    <label>Observaciones</label>
                    <textarea className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-checkbox-circle-line" eventClick={() => handleButtonClick("true")}>Aprobar</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-close-circle-line" eventClick={() => handleButtonClick("false")}>Rechazar</BasicButton>
                </div>
            </div>

        </>
    );
}